module.exports = __webpack_public_path__ + "static/media/Macbook1.f97f947b.png";